import React from "react";
import "./style.scss";
import { Close } from "../../../Icons/IconPackage/Close";
import { useLocaleContext } from "../../../../context/LocaleContext";
import PlayPauseButton from "../../Controls/PlayPauseButton";

export default ({ onClose, playerRef }) => {
    const { get: getLocale } = useLocaleContext();
    const className = 'player-floating-overlay';

    const video = playerRef.current;

    if (!video) return null;

    const handlePlay = () => {
        if (!video) return;
        try {
            video.play()
        } catch (e) {
            console.info(e)
        }
    }

    const handlePause = () => {
        if (!video) return;
        try {
            video.pause()
        } catch (e) {
            console.info(e)
        }
    }

    return (
        <div className={className}>
            <a className={`${className}-close`} onClick={onClose}><Close /></a>
            <a className={`${className}-return`} onClick={onClose}>{getLocale('player.floatingOverlay.returnButton.title')}</a>
            <PlayPauseButton
                paused={video.paused}
                onPlay={handlePlay}
                onPause={handlePause}
            />
        </div>
    );
}
